import React, {useState} from "react";

import styles from "./RegionSearchPanel.style";
import {connect} from "react-redux";
import {
    Panel,
    PanelHeader,
    PanelHeaderBack,
    Input,
    FormLayoutGroup,
    FormLayout,
    ScreenSpinner,
    SimpleCell, Group, List, Text, Div
} from "@vkontakte/vkui";
import { setPreviousPanel } from "../../redux/actions/panelsActions";
import Icon24Done from "@vkontakte/icons/dist/24/done";
import {selectRegion, startFourthStepLoading} from "../../redux/actions/regionAndMedicalOrganisationActions";

const RegionSearchPanel = ({
                               id, regions, selectedRegion, showLoader,
                               goBack, selectRegion, startFourthStepLoading
                           }) => {

    const [regionsToShow, setRegionsToShow] = useState(regions);

    const onInputChange = (e) => {
        setRegionsToShow(getRegionsIncludesUserSearch(regions, e.target.value))
    }

    const getRegionsIncludesUserSearch = (regions, userSearch) => {
        return regions.filter((region) => {
            return getRegionNameInCompareFormat(region).includes(userSearch)
        })
    }

    const getRegionNameInCompareFormat = (region) => {
        let name = region.name;
        name = name.trim();
        name = name.toLowerCase();
        while (name.includes("-")) {
            name = name.replace("-", "")
        }
        while (name.includes(" ")) {
            name = name.replace(" ", "")
        }
        return name;
    }

    const mapRegionToSimpleCell = (region) => {
        return (
            <SimpleCell
                key={region.regionCode}
                onClick={() => {
                    selectRegion(region);
                    startFourthStepLoading(region.OKATO);
                    goBack();
                }}
                after={selectedRegion.name === region.name ? <Icon24Done fill="var(--accent)"/> : null}
            >
                {region.name}
            </SimpleCell>
        )
    }

    return (
        <Panel id={id}>
            <PanelHeader
                left={<PanelHeaderBack onClick={() => goBack()}/>}>
                <span style={styles.blue}>ГОС</span><span style={styles.red}>УСЛУГИ</span>
            </PanelHeader>
            <FormLayout>
                {
                    regions && !showLoader
                        ? <>
                            <FormLayoutGroup top="Регион">
                                <Input type="text" onChange={onInputChange}/>
                            </FormLayoutGroup>
                            <Group>
                                <List>
                                    {
                                        regionsToShow
                                            ? regionsToShow.map(mapRegionToSimpleCell)
                                            : <Text weight="regular">Регион не найден</Text>
                                    }
                                </List>
                            </Group>
                        </>
                        : <Div style={{marginTop: "40vh"}}>
                            <ScreenSpinner/>
                        </Div>
                }

            </FormLayout>
        </Panel>
    )
}

const mapStateToProps = (state) => {

    return {
        regions: state.regionAndMedicalOrganisation.regions,
        selectedRegion: state.regionAndMedicalOrganisation.selectedRegion,
        showLoader: state.loader.showRegionsLoader
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        selectRegion: (region) => dispatch(selectRegion(region)),
        goBack: () => dispatch(setPreviousPanel()),
        startFourthStepLoading: (regionOKATO) => dispatch(startFourthStepLoading(regionOKATO)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(RegionSearchPanel);
